import { create } from 'zustand';
import type { QuestDTO } from '@hexcrawl/shared-utils';

interface QuestState {
  quests: QuestDTO[];
  notification: string | null;
  journalOpen: boolean;
  badgePulsing: boolean;
  badgePulseQueued: boolean;

  setQuests: (quests: QuestDTO[]) => void;
  addOrUpdateQuest: (quest: QuestDTO) => void;
  showNotification: (message: string) => void;
  clearNotification: () => void;
  setJournalOpen: (open: boolean) => void;
  triggerBadgePulse: () => void;
  queueBadgePulse: () => void;
  flushBadgePulse: () => void;
  clear: () => void;
}

export const useQuestStore = create<QuestState>()((set, get) => ({
  quests: [],
  notification: null,
  journalOpen: false,
  badgePulsing: false,
  badgePulseQueued: false,

  setQuests: (quests) => set({ quests }),
  addOrUpdateQuest: (quest) => set((state) => {
    const existing = state.quests.findIndex(q => q.id === quest.id);
    if (existing >= 0) {
      const updated = [...state.quests];
      updated[existing] = quest;
      return { quests: updated };
    }
    return { quests: [...state.quests, quest] };
  }),
  showNotification: (message) => set({ notification: message }),
  clearNotification: () => set({ notification: null }),
  setJournalOpen: (open) => set({ journalOpen: open }),
  triggerBadgePulse: () => {
    set({ badgePulsing: true });
    setTimeout(() => set({ badgePulsing: false }), 1200);
  },
  queueBadgePulse: () => set({ badgePulseQueued: true }),
  flushBadgePulse: () => {
    if (!get().badgePulseQueued) return;
    set({ badgePulseQueued: false, badgePulsing: true });
    setTimeout(() => set({ badgePulsing: false }), 1200);
  },
  clear: () => set({ quests: [], notification: null, journalOpen: false, badgePulsing: false, badgePulseQueued: false }),
}));
